<div class="scroll-helper">
  <button
    #scrollToStartBtn
    class="icon-only-button small hidden scroll-btn-left"
    type="button"
    [attr.aria-label]="
      'pia.features.product-comparison.scrollToStartLabel' | translate
    "
    (click)="scrollToStart()"
  >
    <claas-icon
      [iconId]="'659468'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    ></claas-icon>
  </button>

  <div class="scroll-indicators">
    <div class="indicator-dot" [class.active]="!isScrolledToEnd()"></div>
    <div class="indicator-dot" [class.active]="isScrolledToEnd()"></div>
  </div>

  <button
    #scrollToEndBtn
    class="icon-only-button small scroll-btn-right"
    type="button"
    [attr.aria-label]="
      'pia.features.product-comparison.scrollToEndLabel' | translate
    "
    (click)="scrollToEnd()"
  >
    <claas-icon
      [iconId]="'659468'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    ></claas-icon>
  </button>
</div>
